import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { GlobalState } from '../../global.state';
import { Subscription } from 'rxjs/Subscription';

import { cancelSubscription } from '../../shared/cancelSubscription';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnDestroy {
  isCollapsedID = 'isCollapsed';
  private windowWidth = window.innerWidth;
  private subscription1: Subscription;

  constructor(private _state: GlobalState) { }

  ngOnInit() {
      this.subscription1 = this._state.mainMenuChanged
      .subscribe(() => {
          if (this.isCollapsedID  === 'isCollapsed') {
            this.isCollapsedID = '';
          } else {
            this.isCollapsedID = 'isCollapsed';
          }
      });
  }
  public hideMenu() {
    if (this.windowWidth < 991) {
      this._state.changeMainMenu();
    }
  }

   @HostListener('window:resize', ['$event.target'])
    public onResize() {
      this.windowWidth = window.innerWidth;
      console.log(this.windowWidth > 991 && this.isCollapsedID === '');
      if(this.windowWidth > 991 && this.isCollapsedID === '') {
        this._state.changeMainMenu();
      }
  }

  ngOnDestroy(){
    cancelSubscription([this.subscription1]);
  }

}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/core/menu/menu.component.ts